import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import UserRestServices from '../../services/user-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-user-session-feedback',
	templateUrl: './modal-user-session-feedback.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalUserSessionFeedbackComponent implements OnInit {
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalUserSessionFeedbackComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	handleModalInit() {
		console.log('FEEDBACK', this.vm.subject);
		
		this.vm.data = {};
		this.vm.userId = this.vm.userId;
		this.vm.subject = this.vm.subject;
		this.vm.isPatientEvaluatesSession = this.vm.isPatientEvaluatesSession;
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
	handleFormSubmit(curingSessionHelped) {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		
		var payload: any = {
			user: { id: this.vm.subject.userId },
			curingSessionHelped: curingSessionHelped
		};
		console.log('SESSION_FEEDBACK.PAYLOAD', payload);
		
		this.userRestServices.sendBookingFeedback(payload,
			() => {
				this.handleFormComplete();
			},
			(err) => {
				console.log('SESSION_FEEDBACK.ERROR', err);
			}
		);
	}
	
	handleFormComplete() {
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(() => {
				this.handleFormSuccess();
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		} else {
			this.handleFormSuccess();
		}
	}
	
	handleFormSuccess() {
		this.vm.processing = false;
		this.vm.success = true;
	}
	
}